(function () {
  'use strict';

  // Constructible stylesheets: Chrome 73+, Safari 16.4+. Older browsers just
  // don't get the rescue — same as today, no worse.
  var canAdopt =
    typeof CSSStyleSheet === 'function' &&
    typeof Document !== 'undefined' &&
    'adoptedStyleSheets' in Document.prototype;
  if (!canAdopt) return;

  var patched = new WeakSet();

  function parseRGB(value) {
    var m = String(value).match(/(-?[\d.]+)[,\s]+(-?[\d.]+)[,\s]+(-?[\d.]+)/);
    if (!m) return null;
    var n = [+m[1], +m[2], +m[3]];
    // `color(srgb 1 1 1)` reports 0-1 floats; rgb() reports 0-255.
    if (/^color\(/.test(String(value).trim())) n = n.map(function (c) { return c * 255; });
    return n;
  }

  function isTransparent(value) {
    return !value || value === 'transparent' || /rgba\([^)]*,\s*0\s*\)/.test(value);
  }

  // Relative luminance, WCAG formula.
  function luminance(rgb) {
    var c = rgb.map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  function contrast(a, b) {
    var la = luminance(a), lb = luminance(b);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
  }

  // First ancestor that actually paints something, crossing shadow boundaries.
  function effectiveBackground(el) {
    var n = el;
    while (n) {
      if (n.nodeType === 1) {
        var bg = getComputedStyle(n).backgroundColor;
        if (!isTransparent(bg)) {
          var rgb = parseRGB(bg);
          if (rgb) return rgb;
        }
      }
      n = n.parentElement || (n.parentNode && n.parentNode.host) || null;
    }
    return [255, 255, 255]; // page default
  }

  function eachShadowRoot(root, depth, fn) {
    if (depth > 6) return;
    fn(root);
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) eachShadowRoot(el.shadowRoot, depth + 1, fn);
    });
  }

  function rescue(root) {
    if (patched.has(root)) return;
    var item = root.querySelector('.account__item');
    if (!item) return;

    var color = parseRGB(getComputedStyle(item).color);
    if (!color) return;
    var bg = effectiveBackground(item);

    // 1.6:1 is far below the 4.5:1 readability floor and well under anything
    // a designer would ship on purpose — this only catches "invisible".
    if (contrast(color, bg) > 1.6) return;

    var ink = luminance(bg) > 0.5 ? '#000' : '#fff';
    var sheet = new CSSStyleSheet();
    sheet.replaceSync(
      '.account__item, .account__item-text { color: ' + ink + ' !important; }'
    );
    root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    patched.add(root);
  }

  function sweep() {
    document.querySelectorAll('shopify-account').forEach(function (host) {
      if (!host.shadowRoot) return;
      eachShadowRoot(host.shadowRoot, 0, rescue);
    });
  }

  // The component hydrates async and attaches its shadow roots without ever
  // mutating the light DOM, so a MutationObserver alone can miss it. A short
  // bounded retry covers hydration; the observer covers the host arriving
  // late (or a re-render). Both stop on their own — no polling loop.
  [0, 300, 1000, 3000].forEach(function (delay) { setTimeout(sweep, delay); });

  if (typeof MutationObserver === 'function') {
    var seen = 0;
    var mo = new MutationObserver(function () {
      sweep();
      if (++seen > 40) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
